/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_AgentsInputs */

const en_mk_shot_agents = /** @type {(inputs: Mk_Shot_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The workspace’s AI agents, each with its role, division and month-to-date cost.`)
};

const id_mk_shot_agents = /** @type {(inputs: Mk_Shot_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar agen AI di workspace, lengkap dengan peran, divisi, dan biaya bulan berjalan.`)
};

/**
* | output |
* | --- |
* | "The workspace’s AI agents, each with its role, division and month-to-date cost." |
*
* @param {Mk_Shot_AgentsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_agents = /** @type {((inputs?: Mk_Shot_AgentsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_AgentsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_agents(inputs)
	return en_mk_shot_agents(inputs)
});